<script setup>
import LabelForInput from "@/components/form/LabelForInput.vue";
import MySpacer from      "@/components/form/Spacer.vue";
const props = defineProps({
  hint: "",
  label: "",
  name: "",
  value: "",
});

</script>

<template>
  <div :class="['form-group']">
    <MySpacer />
    <LabelForInput :name :hint :label v-if="label"/>
    <div class="">
      {{ value }}
    </div>
  </div>
</template>
